import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

const API_URL = import.meta.env.VITE_API_URL || '';

export function useLabelPrintersQuery({ enabled }) {
    const query = useQuery({
        queryKey: ['label-printers'],
        queryFn: async () => {
            const response = await axios.get(`${API_URL}/api/app/label-printers`, { withCredentials: true });
            return response?.data?.data?.locations ?? [];
        },
        enabled,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });

    return {
        ...query,
        locations: query.data ?? [],
    };
}
